<template>

  <div class="container pt-4 mb-4">

    <div>

      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Płeć:
              </label>

              <b-input-group>

                <b-form-input v-model="gender" size="lg" ref="gender" rows=10 placeholder="np. kobieta"></b-form-input>

              </b-input-group>

            </div>


            
            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Narodowość:
              </label>

              <b-input-group>

                <b-form-input v-model="nationality" size="lg" ref="nationality" rows=10 placeholder="np. polska"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Wiek:
              </label>

              <b-input-group>

                <b-form-input v-model="age" size="lg" ref="age" rows=10 placeholder="np. 30"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Kolor włosów:
              </label>

              <b-input-group>

                <b-form-input v-model="hairColor" size="lg" ref="hairColor" rows=10 placeholder="np. blond"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Charakter:
              </label>

              <b-input-group>

                <b-form-input v-model="character" size="lg" ref="character" rows=10 placeholder="np. agresywna uroda, miła uśmiechnięta"></b-form-input>

              </b-input-group>

            </div>

            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Wzrost:
              </label>

              <b-input-group>

                <b-form-input v-model="height" size="lg" ref="height" rows=10 placeholder="np. wysoka"></b-form-input>

              </b-input-group>

            </div>


          </div>

        </b-col>

      </b-row>

      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">

        </b-col>

        <b-col lg="6">

          <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
            Generuj influencera
          </b-button>

        </b-col>

      </b-row>

 
      <div class="mt-2" >

        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje grafikę <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Proszę czekać...</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" style="font-size: 1em;">

            <img ref="outputImg" style="width:100%;height:auto;" src="" />

          </blockquote>

        </b-card>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'AppGraphicAi',
  components: {
  },
  data() {
    return {
      isFinish: false,
      result: "",
      generatedImg: false,
      imageBase64: null,
      selectedText: '',
      query: "",
      gender: "",
      hairColor: "",
      character: "",
      height: "",
      age: "",
      nationality: "",
      finishContent: '',
      selectedSchema: null
    }
  },
  methods: {
 
    generateFinish: function() {

      if(!this.gender) return false;
      if(!this.hairColor) return false;
      if(!this.character) return false;
      if(!this.height) return false;
      if(!this.age) return false;
      if(!this.nationality) return false;

      this.$refs.generatePost.disabled = true

      this.isFinish = true

      this.finishContent = ""
      this.result = ""

      var prompt =  "Stwórz mi realistyczne zdjęcie ujęcie średni kadr osoby influencera płeć " + this.gender + " o narodowości " + this.nationality + " w wieku " + this.age + " lat, włosy:  " + this.hairColor + ",Charakter osoby " + this.character + ", Wzrost " + this.height + ". Zdjęcie ma być w stylu profesjonalnej fotografii studyjnej, oświetlenie miękkie, tło neutralne, wysokiej jakości, realistyczne detale twarzy i ubioru.";

      this.axios.post(window.API_URL + "apps/graphicAi/paintnb/", { 'prompt': prompt }, { withCredentials: true, timeout: 60000 }).then((response2) => {

          let data = response2.data

          this.finishContent = true;

          this.$refs.outputImg.src = "data:image/jpeg;charset=utf-8;base64," + data.base64;

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana grafika"


        }).catch(function() {

          this.$refs.generatePost.disabled = false

        });



    }

  },
  computed: {

  },
  created() {

    this.$watch('finishContent', (value) => {

      var lines = value.split(/\r|\r\n|\n/);

      this.finishLinesCount = lines.length;

    })

  }

}
</script>

<style>

.pointer { cursor: pointer; }
.bold { font-weight: 600 !important; }
code { color: #4e82f7 !important; }
</style>